import React from 'react';
import styled from 'styled-components';
import { Level, Title } from 'rbx';
import qs from 'querystringify';
import { omit } from 'lodash';
import { Input, Radio } from '../../../components/elements';
import LocationSuggestion from '../../../components/global/LocationSuggestion';
import PlaceSearchInput from '../../../components/global/PlaceSearchInput';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const TitleWrapper = styled.nav`
  padding-right: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const Search = ({
  status,
  publish,
  // placeName,
  menuName,
  city,
  serviceType,
  routeState,
  history,
  // defaultPlace,
}) => {
  const handlePush = (args, key) => {
    const newRoutState = omit(routeState, key);
    history.push(
      `/menus${qs.stringify(
        {
          ...newRoutState,
          ...args,
          page: 1,
        },
        true,
      )}`,
    );
  };

  return (
    <Wrapper>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingBottom: '2rem',
        }}
      >
        <Level.Item
          align="left"
          style={{
            paddingRight: '1rem',
          }}
        >
          <Level.Item>
            <TitleWrapper>
              <Title className="label">Status</Title>
            </TitleWrapper>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="ACTIVE"
                value={status === 'ACTIVE'}
                onChange={() => {
                  handlePush({ status: 'ACTIVE' }, 'status');
                }}
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="INACTIVE"
                value={status === 'INACTIVE'}
                onChange={() => {
                  handlePush({ status: 'INACTIVE' }, 'status');
                }}
              />
            </div>
          </Level.Item>
        </Level.Item>
        <Level.Item align="left">
          <Level.Item>
            <TitleWrapper>
              <Title className="label">Publish</Title>
            </TitleWrapper>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="ON"
                value={publish === 'ON'}
                onChange={() => {
                  handlePush({ publish: 'ON' }, 'publish');
                }}
              />
            </div>
          </Level.Item>
          <Level.Item>
            <div>
              <Radio
                label="OFF"
                value={publish === 'OFF'}
                onChange={() => {
                  handlePush({ publish: 'OFF' }, 'publish');
                }}
              />
            </div>
          </Level.Item>
        </Level.Item>
      </div>
      <BoxWrapper className="box">
        <div className="columns">
          <div className="column is-3">
            <PlaceSearchInput />
            {/* <Input
              label="Place Name"
              id="MenuDesigner_PlaceName"
              type="text"
              value={placeName}
              onChange={event => {
                handlePush({ placeName: event.target.value }, 'placeName');
              }}
              key={defaultPlace}
              placeholder="Enter the Place name..."
            /> */}
          </div>

          <div className="column is-3">
            <div className="field">
              <label className="label">City / Suburb</label>
              <div className="control">
                <LocationSuggestion
                  initialValue={city || ''}
                  onSelect={value => {
                    handlePush({ city: value.name }, 'city');
                  }}
                  onHandleClear={() => handlePush({ city: '' }, 'city')}
                  placeholder="Start entering company name..."
                />
              </div>
            </div>
          </div>

          <div className="column is-3">
            <Input
              label="Service Type"
              id="MenuDesigner_ServiceType"
              type="text"
              value={serviceType}
              onChange={event => {
                handlePush({ serviceType: event.target.value }, 'serviceType');
              }}
              placeholder="Enter the Service Type..."
            />
          </div>

          <div className="column is-3">
            <Input
              label="Menu Name"
              id="MenuDesigner_MenuName"
              type="text"
              value={menuName}
              onChange={event => {
                handlePush({ menuName: event.target.value }, 'menuName');
              }}
              placeholder="Enter the Menu name..."
            />
          </div>
        </div>
      </BoxWrapper>
    </Wrapper>
  );
};

export default Search;
